export default "__VITE_ASSET__BXF$Hkkp__"